<template>
  <div class="modal-reset-ques-num-stdb-question">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container-outer">
          <ButtonClose
            class="modal-default-button"
            @click="showCheckCloseModal"
          />
          <div
            ref="modalContainer"
            class="modal-container"
          >
            <div class="h-100 w-100 modal-contents-area">
              <div class="d-flex justify-content-around modal-contents-area-inner">
                <!-- 設定 -->
                <div class="modal-contents-area-left">
                  <div class="h-100 p-3 card setting-area">
                    <FormTextField
                      :label-text="$t('labels.taskName')"
                      :initial-value="taskName"
                      :max-length="50"
                      :disabled="true"
                      @input="inputTaskName"
                      @on-blur="blurTaskName"
                    />
                    <div
                      v-if="showMsgTaskName"
                      class="text-danger"
                    >
                      {{ showMsgTaskName }}
                    </div>
                    <br>
                    <div v-once>
                      {{ $t("labels.howToDisplayInViewer") }}
                    </div>
                    <div id="display-method">
                      <label class="px-4 py-1">
                        <input
                          v-model="checkDisplayMethod"
                          type="radio"
                          value="oneQuestion"
                          :disabled="true"
                        >
                        {{ $t("labels.oneQuestion") }}
                      </label>
                      <div class="px-5 py-1">
                        <label>
                          <input
                            id="chkAnswer"
                            v-model="answerValue"
                            type="checkbox"
                            :disabled="true"
                            @change="onChangedCheckboxValue"
                          >
                          <label for="chkOneQuestion">{{
                            $t("labels.answer")
                          }}</label>
                          &nbsp;&nbsp;
                        </label>
                        <label>
                          <input
                            id="chkExplanation"
                            v-model="explanationValue"
                            type="checkbox"
                            :disabled="true"
                            @change="onChangedCheckboxValue"
                          >
                          <label for="chkExplanation">{{
                            $t("labels.explanation")
                          }}</label>
                        </label>
                      </div>
                      <!-- Docがない場合、ラジオ非表示 -->
                      <div>
                        <label class="mx-4 py-1">
                          <input
                            v-model="checkDisplayMethod"
                            type="radio"
                            value="followLayout"
                            :disabled="true"
                          >
                          {{ $t("labels.followLayout") }}
                        </label>
                      </div>
                    </div>
                    <div>
                      <br>
                      <div>
                        {{ $t("labels.questionQuantity") }}
                      </div>
                      <div class="question-area">
                        <div class="question-amount mx-3">
                          <div
                            v-for="(item, index) in questionQuantityList"
                            :key="index"
                          >
                            <div class="row py-1">
                              <div
                                v-if="stdbPreviewNum === 0 && checkDisplayMethod != 'followLayout'"
                                class="col-3 text-center"
                              >
                                {{ "[" + (Number(index) + 1) + "]" }}
                              </div>
                              <div
                                class="col-2 p-0 text-end"
                                @click="onClickQuestionCountMinus(index)"
                              >
                                <i class="icon-minus bi bi-dash-circle-fill" />
                              </div>
                              <div class="col-3 p-0 text-center">
                                {{
                                  $t("labels.questionNumber", { number: item })
                                }}
                              </div>
                              <div
                                class="col-2 p-0 text-start"
                                @click="onClickQuestionCountPlus(index)"
                              >
                                <i class="icon-plus bi bi-plus-circle-fill" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <FormTextField
                      :label-text="$t('labels.sendMemo')"
                      :initial-value="sendMemo"
                      :max-length="50"
                      :disabled="true"
                      @input="inputSendMemo"
                      @on-blur="blurSendMemo"
                    />
                    <div
                      v-if="showMsgSendMemo"
                      class="text-danger"
                    >
                      {{ showMsgSendMemo }}
                    </div>
                  </div>
                </div>

                <!-- プレビュー -->
                <div class="modal-contents-area-right preview-image-container">
                  <div v-if="checkDisplayMethod == 'oneQuestion'" class="card w-100 h-100 d-flex flex-column">
                    <div class="card-header">
                      {{ $t("labels.preview") }}
                    </div>
                    <div class="window-body d-flex flex-column flex-fill">
                      <div v-if="stdbPreviewNum === 0" class="ps-3 preview-image-question-count">
                        {{ "[" + (oneQuestionCount + 1) + "]" }}
                      </div>
                      <div class="preview-top pb-2">
                        <div class="card overflow-auto h-100">
                          <SettingPreviewImage
                            v-if="imageQList.length"
                            :image="imageQList[oneQuestionCount].file_image"
                            class="card-body"
                          />
                        </div>
                      </div>
                      <div class="preview-bottom pt-2">
                        <SettingPreviewArea
                          ref="previewArea"
                          :list="settingList[oneQuestionCount]"
                          :stdb-flg="true"
                        />
                      </div>
                      <ul class="prev-area">
                        <li
                          v-show="
                            checkDisplayMethod == 'oneQuestion' &&
                              oneQuestionCount > 0
                          "
                          class="prev"
                          @click="onClickArrowMinus"
                        />
                      </ul>
                      <ul class="next-area">
                        <li
                          v-show="
                            checkDisplayMethod == 'oneQuestion' &&
                              oneQuestionCount < imageQList.length - 1
                          "
                          class="next"
                          @click="onClickArrowPlus"
                        />
                      </ul>
                    </div>
                  </div>
                  <div v-else class="card w-100 h-100 d-flex flex-column">
                    <div class="card-header d-flex justify-content-between align-items-center">
                      {{ $t("labels.preview") }}
                      <div class="preview-image-layout-count">
                        {{ layoutCount + 1 + " / " + imageDocList.length }}
                      </div>
                    </div>
                    <div class="window-body d-flex flex-column flex-fill">
                      <div class="preview-window">
                        <div class="card overflow-auto h-100">
                          <SettingPreviewImage
                            v-if="imageDocList.length"
                            :image="imageDocList[layoutCount].file_image"
                            class="card-body"
                          />
                        </div>
                      </div>
                      <ul class="prev-area">
                        <li
                          v-show="
                            checkDisplayMethod == 'followLayout' &&
                              layoutCount > 0
                          "
                          class="prev"
                          @click="onClickArrowMinus"
                        />
                      </ul>
                      <ul class="next-area">
                        <li
                          v-show="
                            checkDisplayMethod == 'followLayout' &&
                              layoutCount < imageDocList.length - 1
                          "
                          class="next"
                          @click="onClickArrowPlus"
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 注釈 -->
              <div
                class="d-flex justify-content-end mb-2"
                :class="{ hidden: checkDisplayMethod != 'followLayout' }"
              >
                <div
                  class="col-12"
                  style="text-align: right"
                >
                  <div
                    style="
                      font-size: 70%;
                      text-align: left;
                      position: relative;
                      display: inline-block;
                    "
                  >
                    {{ $t("labels.recommendPageMessage") }}
                  </div>
                </div>
              </div>

              <!-- アクションボタン -->
              <div class="row gx-5 justify-content-center">
                <div class="col-auto">
                  <ButtonBorderCircleMedium
                    :label-name="$t('buttons.cancel')"
                    :label-color="colorLayoutTheme"
                    :border-color="colorLayoutTheme"
                    @click="$emit('close')"
                  />
                </div>
                <div class="col-auto">
                  <!-- 保存処理 -->
                  <ButtonBorderCircleMedium
                    :label-name="$t('buttons.save')"
                    color="layout-theme-light"
                    :label-color="colorLayoutTheme"
                    :border-color="colorLayoutTheme"
                    @click="onClickSave"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 閉じるメッセージ用 -->
    <ModalConfirm
      v-if="showCautionCloseMessage"
      :message="$t('messages.confirm.notSavedOriginalFile')"
      v-on="{
        'ok-confirm-modal': onClickOkForCautionCloseMessage,
        'close-confirm-modal': onClickCloseForCautionCloseMessage,
      }"
    />
  </div>
</template>

<script>
/**
 * 宿題管理 - STDBプレビューモーダル
 */
import { db } from "@/dbs/indexedDb"
import ButtonClose from "@/components/atoms/buttons/ButtonClose.vue"
import FormTextField from "@/components/atoms/FormTextField.vue"
import ButtonBorderCircleMedium from "@/components/atoms/buttons/ButtonBorderCircleMedium.vue"
import SettingPreviewImage from "@/components/atoms/SettingPreviewImage.vue"
import SettingPreviewArea from "@/components/organisms/SettingPreviewArea.vue"
import ModalConfirm from "@/components/organisms/modal/ModalConfirm.vue"
import { displayFlagCode, settingTabIdCode } from "@/constant/question.js"

export default {
  name: "ModalResetQuesNumStdbQuestion",
  components: {
    ButtonClose,
    FormTextField,
    ButtonBorderCircleMedium,
    SettingPreviewImage,
    SettingPreviewArea,
    ModalConfirm,
  },
  props: {
    taskName: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },

    sendMemo: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },

    imageList: {
      type: Array,
      default: function () {
        return []
      },
    },

    // ファイルパス
    filePath: {
      type: String,
      default: "",
    },
  },

  emits: [
    "close",
    "save",
  ],
  data: () => ({
    colorLayoutTheme: "#ff7f27",
    modalTaskName: "", // 課題名
    modalSendMemo: "", // 送信メモ
    showMsgTaskName: "", // 課題名エラーメッセージ
    showMsgSendMemo: "", // 送信メモエラーメッセージ
    answerValue: false, // 答えチェックボックスの値
    explanationValue: false, // 解説チェックボックスの値
    checkDisplayMethod: "oneQuestion", // 選択中のラジオボタンの文字列
    oneQuestionCount: 0, // 一問ずつ画像の何番目かのカウンター
    layoutCount: 0, // レイアウト通り画像の何番目かのカウンター

    imageQList: [], // 問題画像リスト
    imageEList: [], // 解説画像リスト
    imageAList: [], // 答え画像リスト
    imageDocList: [], // レイアウト通り画像リスト

    /**
     * 画像表示エリア下部分に表示するjsonデータ
     * 例：
     * [
     *  { "id": 1, "label": "答", "content": "data:image/png;base64,iVBORw0KGgo..." },
     *  { "id": 2, "label": "解説", "content": "data:image/png;base64,iVBORw0KGgo..." },
     * ]
     */
    settingList: [],
    isCheckBoxDisabled: false, // チェックボックスが無効状態かどうか
    questionQuantityList: [], // 問題数入力
    stdbPreviewNum: 0,
    showCautionCloseMessage: false,
  }),

  beforeMount: async function () {
    // 画像の振り分け
    this.imageDocList = this.imageList.filter((item) => {
      // 前方一致"{数値}"
      return item.file_name.match(/^\d/)
    })
    this.imageQList = this.imageList.filter((item) => {
      // 前方一致"Q{数値}"
      return item.file_name.match(/^Q\d/)
    })
    this.imageEList = this.imageList.filter((item) => {
      // 前方一致"E{数値}"
      return item.file_name.match(/^E\d/)
    })
    this.imageAList = this.imageList.filter((item) => {
      // 前方一致"A{数値}"
      return item.file_name.match(/^A\d/)
    })

    // 入力項目の初期設定
    this.modalTaskName = this.taskName
    this.modalSendMemo = this.sendMemo
  },

  mounted: async function () {
    // リサイズ時にモーダルサイズの調整を行う（iPad対応）
    window.addEventListener('resize', () => {
      this.adjustModal();
    });
    this.adjustModal();

    // 初期表示
    if (this.filePath != "") {
      const result = await this.getUploadHomeworkDetailItems(this.filePath)
      if (result !== undefined) {
        this.questionQuantityList =
          result.uploadHomeworkDetailItem.questionCount
      }
    }

    if (!this.imageQList.length) {
      // DOCファイルしかない場合
      this.checkDisplayMethod = "followLayout"
    }

    if (!this.questionQuantityList.length) {
      if (this.checkDisplayMethod === "oneQuestion") {
        for (var i = 0; i < this.imageQList.length; i++) {
          this.questionQuantityList[i] = 1
        }
      } else {
        //問題数は1つ
        this.questionQuantityList[0] = 1
      }
    }

    // 一問ずつの場合タブを表示
    if (this.checkDisplayMethod === "oneQuestion") {
      // 一問ずつの場合タブを表示
      this.answerValue = 0 < this.imageAList.length
      this.explanationValue = 0 < this.imageEList.length
      // タブの生成
      this.onChangedCheckboxValue()
      // タブ選択の設定
      this.$refs.previewArea.setCurrentId(settingTabIdCode.answerId)
    }
  },

  methods: {
    /**
     * モーダルサイズ調整
     */
    adjustModal() {
      var e = this.$refs.modalContainer;
      if (e) {
        var v = window.innerHeight;
        e.style.height = `${ (v - 20) }px`;
      }
    },

    /**
     * 登録処理
     */
    onClickSave: function () {
      this.$emit("save", {
        questionQuantityList: this.questionQuantityList, // 問題数
        modalTaskName: this.modalTaskName, // 課題名
        modalSendMemo: this.modalSendMemo, // 送信メモ
        answerValue: this.answerValue, // 答えチェックボックスの値
        explanationValue: this.explanationValue, // 解説チェックボックスの値
      })
    },

    /**
     * アップロード一覧（IndexedDB）取得
     */
    async getUploadHomeworkDetailItems(filePath) {
      return await db.uploadHomeworkDetailItems.get(filePath)
    },

    /**
     * 表示画像のインデックスカウントアップ
     */
    onClickArrowPlus: function () {
      if (this.checkDisplayMethod == "oneQuestion") {
        this.oneQuestionCount =
          (this.oneQuestionCount + 1) % this.imageQList.length
      } else {
        this.layoutCount = (this.layoutCount + 1) % this.imageDocList.length
      }
    },

    /**
     * 表示画像のインデックスカウントダウン
     */
    onClickArrowMinus: function () {
      if (this.checkDisplayMethod == "oneQuestion") {
        this.oneQuestionCount = this.oneQuestionCount - 1
        if (this.oneQuestionCount < 0) {
          this.oneQuestionCount = this.oneQuestionCount + this.imageQList.length
        }
      } else {
        this.layoutCount = this.layoutCount - 1
        if (this.layoutCount < 0) {
          this.layoutCount = this.layoutCount + this.imageDocList.length
        }
      }
    },

    /**
     * 問題数の[+]押したとき
     */
    onClickQuestionCountPlus: function (number) {
      this.questionQuantityList[number] =
        this.questionQuantityList[number] + 1
      // 最大50まで
      if (this.questionQuantityList[number] > 50) {
        this.questionQuantityList[number] = 50
      }
    },

    /**
     * 問題数の[-]押したとき
     */
    onClickQuestionCountMinus: function (number) {
      this.questionQuantityList[number] =
        this.questionQuantityList[number] + -1
      // 最小1まで
      if (this.questionQuantityList[number] < 1) {
        this.questionQuantityList[number] = 1
      }
    },

    /**
     * 課題名入力値取得
     */
    inputTaskName: function (text) {
      this.modalTaskName = text
    },

    /**
     * 送信メモ入力値取得
     */
    inputSendMemo: function (text) {
      this.modalSendMemo = text
    },

    /**
     * 課題名フォーカスアウト処理
     */
    blurTaskName: function (text) {
      this.showMsgTaskName = ""
      // 課題名必須チェック
      if (text.length > 50) {
        this.showMsgTaskName = this.$t("messages.error.overTextLength", {
          maxLength: "50",
        })
      }
    },

    /**
     * 送信メモフォーカスアウト処理
     */
    blurSendMemo: function (text) {
      this.showMsgSendMemo = ""
      // 送信メモ必須チェック
      if (text.length > 50) {
        this.showMsgSendMemo = this.$t("messages.error.overTextLength", {
          maxLength: "50",
        })
      }
    },

    /**
     * チェックボックスの値が変化した時
     */
    onChangedCheckboxValue: function () {
      this.settingList.splice(0)

      for (var i = 0; i < this.imageQList.length; i++) {
        if (this.answerValue) {
          if (this.explanationValue) {
            this.settingList.push(
              ...[
                [
                  {
                    id: settingTabIdCode.answerId,
                    label: this.$t("labels.answer"),
                    content: this.imageAList.length
                      ? this.imageAList[i].file_image
                      : "",
                    displayFlag: displayFlagCode.display,
                    tagIndex: 1,
                  },
                  {
                    id: settingTabIdCode.explainId,
                    label: this.$t("labels.explanation"),
                    content: this.imageEList.length
                      ? this.imageEList[i].file_image
                      : "",
                    displayFlag: displayFlagCode.display,
                    tagIndex: 2,
                  },
                ],
              ]
            )
          } else {
            this.settingList.push(
              ...[
                [
                  {
                    id: settingTabIdCode.answerId,
                    label: this.$t("labels.answer"),
                    content: this.imageAList.length
                      ? this.imageAList[i].file_image
                      : "",
                    displayFlag: displayFlagCode.display,
                    tagIndex: 1,
                  },
                  {
                    id: settingTabIdCode.explainId,
                    label: this.$t("labels.explanation"),
                    content: this.imageEList.length
                      ? this.imageEList[i].file_image
                      : "",
                    displayFlag: displayFlagCode.grayout,
                    tagIndex: 2,
                  },
                ],
              ]
            )
            this.$refs.previewArea.setCurrentId(settingTabIdCode.answerId)
          }
        } else {
          if (this.explanationValue) {
            this.settingList.push(
              ...[
                [
                  {
                    id: settingTabIdCode.answerId,
                    label: this.$t("labels.answer"),
                    content: this.imageAList.length
                      ? this.imageAList[i].file_image
                      : "",
                    displayFlag: displayFlagCode.grayout,
                    tagIndex: 1,
                  },
                  {
                    id: settingTabIdCode.explainId,
                    label: this.$t("labels.explanation"),
                    content: this.imageEList.length
                      ? this.imageEList[i].file_image
                      : "",
                    displayFlag: displayFlagCode.display,
                    tagIndex: 2,
                  },
                ],
              ]
            )
            this.$refs.previewArea.setCurrentId(settingTabIdCode.answerId)
          }
        }
      }

      this.isCheckBoxDisabled = !this.isCheckBoxDisabled
    },

    /**
     * 閉じるボタン
     */
    showCheckCloseModal() {
      if (!this.isDisabled) {
        this.showCautionCloseMessage = true
      } else {
        this.$emit("close")
      }
    },
    onClickOkForCautionCloseMessage() {
      this.showCautionCloseMessage = false
      this.$emit("close")
    },
    onClickCloseForCautionCloseMessage() {
      this.showCautionCloseMessage = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container-outer {
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      .modal-default-button {
        position: absolute;
        left: calc(100vw - 50px);
      }

      .modal-container {
        position: relative;
        width: calc(100vw - 100px);
        height: calc(100vh - 20px);
        margin: auto;
        padding: 15px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;

        .modal-contents-area {
          display: flex;
          flex-direction: column;

          .modal-contents-area-inner {
            flex-grow: 1;
            min-height: 0;
          }

          .modal-contents-area-left {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 33%;
            padding-right: 30px;
          }

          .modal-contents-area-right {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 67%;
          }
        }
      }

      .preview-image-question-count {
        position: absolute;
        left: 0px;
      }

      .preview-image-layout-count {
        color: var(--bs-body-color);
        font-weight: normal;
      }

      .prev-area {
        position: absolute;
        top: 50%;
        left: 12px;
        margin: 0;
        padding: 0;
      }

      .prev {
        display: block;
        padding: 20px 15px;
        cursor: pointer;
        height: auto;
        transform: translateY(-50%);

        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(-45deg);
          top: 12px;
          left: 5px;
        }

        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(45deg);
          top: 24px;
          left: 5px;
        }
      }

      .next-area {
        position: absolute;
        top: 50%;
        right: 12px;
        margin: 0;
        padding: 0;
      }

      .next {
        display: block;
        padding: 20px 15px;
        cursor: pointer;
        height: auto;
        transform: translateY(-50%);

        &::before {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(-45deg);
          top: 24px;
          right: 5px;
        }

        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          background: #0070c0;
          width: 20px;
          height: 4px;
          transform: rotate(45deg);
          top: 12px;
          right: 5px;
        }
      }
    }
  }
}

.setting-area {
  overflow-y: auto;
}

.preview-image-container {
  height: 100%;

  .card-header {
    border-bottom: none;
    background: var(--bs-table-header);
    color: var(--bs-layout-theme);
    font-weight: bold;
  }
}

.window-body {
  padding: 1rem 54px;
  position: relative;
  min-height: 0;
}

span.number {
  display: inline-block;
  width: 35px;
}

.preview-top {
  min-height: 0;
  flex: 0 0 50%;
}

.preview-bottom {
  min-height: 0;
  flex: 0 0 50%;
}

.preview-window {
  min-height: 0;
  flex: 1;
}

// 問題数の数字部分
.question-amount {
  @media (max-width: 1020px) {
    padding-left: 0;
  }

  li {
    div {
      min-width: 210px;
    }
  }
}

.question-area {
  word-wrap: normal;

  .icon-minus:before,
  .icon-plus:before {
    color: #0070c0;

    font-size: 120%;
    vertical-align: bottom;
    cursor: pointer;
  }
}

.hidden {
  visibility: hidden;
}
</style>
